import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_10c5f02a from 'nuxt_plugin_sentryserver_10c5f02a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_a9e702bc from 'nuxt_plugin_sentryclient_a9e702bc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_af9a195a from 'nuxt_plugin_plugin_af9a195a' // Source: ./css/plugin.js (mode: 'server')
import nuxt_plugin_vuescrollto_053430e3 from 'nuxt_plugin_vuescrollto_053430e3' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_workbox_3d926a02 from 'nuxt_plugin_workbox_3d926a02' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_692ae1d6 from 'nuxt_plugin_metaplugin_692ae1d6' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_5fdb96ee from 'nuxt_plugin_iconplugin_5fdb96ee' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_b3363c56 from 'nuxt_plugin_recaptcha_b3363c56' // Source: ./recaptcha.js (mode: 'client')
import nuxt_plugin_axios_7d65f666 from 'nuxt_plugin_axios_7d65f666' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_domain_1fa48ff7 from 'nuxt_plugin_domain_1fa48ff7' // Source: ../src/plugins/domain.server (mode: 'server')
import nuxt_plugin_axios_ed7adb9e from 'nuxt_plugin_axios_ed7adb9e' // Source: ../src/plugins/axios.server (mode: 'server')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../src/plugins/axios (mode: 'all')
import nuxt_plugin_errorhandler_1dde38cf from 'nuxt_plugin_errorhandler_1dde38cf' // Source: ../src/plugins/error-handler (mode: 'all')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../src/plugins/global-components (mode: 'all')
import nuxt_plugin_hokifyprepareusersignup_6631c251 from 'nuxt_plugin_hokifyprepareusersignup_6631c251' // Source: ../src/plugins/hokify-prepare-usersignup.client (mode: 'client')
import nuxt_plugin_hjclient_bf8de2ba from 'nuxt_plugin_hjclient_bf8de2ba' // Source: ../../../libs-frontend/shared-components/lib/plugins/hotjar/hj.client.js (mode: 'client')
import nuxt_plugin_trackingclient_6b7dd6ef from 'nuxt_plugin_trackingclient_6b7dd6ef' // Source: ../../../libs-frontend/tracking/tracking.client.ts (mode: 'client')
import nuxt_plugin_intersectionobserver_86811dd6 from 'nuxt_plugin_intersectionobserver_86811dd6' // Source: ../src/plugins/intersection-observer.client (mode: 'client')
import nuxt_plugin_ismobile_1229dbc2 from 'nuxt_plugin_ismobile_1229dbc2' // Source: ../src/plugins/ismobile (mode: 'all')
import nuxt_plugin_linkbrowser_7e86b04e from 'nuxt_plugin_linkbrowser_7e86b04e' // Source: ../src/plugins/link-browser.client (mode: 'client')
import nuxt_plugin_sharedcomponents_ad92fe70 from 'nuxt_plugin_sharedcomponents_ad92fe70' // Source: ../src/plugins/shared-components (mode: 'all')
import nuxt_plugin_gmapvue_0d9ccc35 from 'nuxt_plugin_gmapvue_0d9ccc35' // Source: ../src/plugins/gmap-vue.client (mode: 'client')
import nuxt_plugin_website_203e8d18 from 'nuxt_plugin_website_203e8d18' // Source: ../src/plugins/website.client (mode: 'client')
import nuxt_plugin_chatclient_32279974 from 'nuxt_plugin_chatclient_32279974' // Source: ../../../libs-frontend/shared-components/lib/plugins/chat.client.js (mode: 'client')
import nuxt_plugin_login_1c4d98fc from 'nuxt_plugin_login_1c4d98fc' // Source: ../../../libs-frontend/login-stack/lib/plugins/login.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"hokify - deine mobile Job-Plattform","meta":[{"hid":"charset","charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"initial-scale=1,maximum-scale=5,minimum-scale=1,width=device-width"},{"hid":"description","name":"description","content":"hokify"},{"hid":"robots","name":"robots","content":"noindex, nofollow"},{"hid":"fb:app_id","property":"fb:app_id","content":"1031146320229277"},{"hid":"fb:pages","property":"fb:pages","content":"435703749965571"},{"hid":"apple-mobile-web-app-status-bar-style","name":"apple-mobile-web-app-status-bar-style","content":"#0fb1af"},{"hid":"apple-mobile-web-app-capable","name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"p:domain_verify","name":"p:domain_verify","content":"5e09a1f7c9de8abbf0f1a235d24b9ac9"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@hokify"},{"hid":"twitter:creator","name":"twitter:creator","content":"hokify"},{"hid":"twitter:title","name":"twitter:title","content":"hokify - deine mobile Job-Plattform"},{"hid":"twitter:description","name":"twitter:description","content":"Exklusive Jobs die man wo anders nicht findet. Bewerbung von überall. Rückmeldung zu jeder Zeit. Die besten Jobs entdecken auf deiner mobilen Job-Plattform."},{"hid":"og:title","property":"og:title","content":"hokify - deine mobile Job-Plattform"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"hokify"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficon.png"}],"style":[{"cssText":"","data-critical":"ssr","data-embed":"ssr"}],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_10c5f02a === 'function') {
    await nuxt_plugin_sentryserver_10c5f02a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_a9e702bc === 'function') {
    await nuxt_plugin_sentryclient_a9e702bc(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin_af9a195a === 'function') {
    await nuxt_plugin_plugin_af9a195a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_053430e3 === 'function') {
    await nuxt_plugin_vuescrollto_053430e3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3d926a02 === 'function') {
    await nuxt_plugin_workbox_3d926a02(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_692ae1d6 === 'function') {
    await nuxt_plugin_metaplugin_692ae1d6(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_5fdb96ee === 'function') {
    await nuxt_plugin_iconplugin_5fdb96ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recaptcha_b3363c56 === 'function') {
    await nuxt_plugin_recaptcha_b3363c56(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7d65f666 === 'function') {
    await nuxt_plugin_axios_7d65f666(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_domain_1fa48ff7 === 'function') {
    await nuxt_plugin_domain_1fa48ff7(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_axios_ed7adb9e === 'function') {
    await nuxt_plugin_axios_ed7adb9e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_errorhandler_1dde38cf === 'function') {
    await nuxt_plugin_errorhandler_1dde38cf(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hokifyprepareusersignup_6631c251 === 'function') {
    await nuxt_plugin_hokifyprepareusersignup_6631c251(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hjclient_bf8de2ba === 'function') {
    await nuxt_plugin_hjclient_bf8de2ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingclient_6b7dd6ef === 'function') {
    await nuxt_plugin_trackingclient_6b7dd6ef(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intersectionobserver_86811dd6 === 'function') {
    await nuxt_plugin_intersectionobserver_86811dd6(app.context, inject)
  }

  if (typeof nuxt_plugin_ismobile_1229dbc2 === 'function') {
    await nuxt_plugin_ismobile_1229dbc2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_linkbrowser_7e86b04e === 'function') {
    await nuxt_plugin_linkbrowser_7e86b04e(app.context, inject)
  }

  if (typeof nuxt_plugin_sharedcomponents_ad92fe70 === 'function') {
    await nuxt_plugin_sharedcomponents_ad92fe70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gmapvue_0d9ccc35 === 'function') {
    await nuxt_plugin_gmapvue_0d9ccc35(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_website_203e8d18 === 'function') {
    await nuxt_plugin_website_203e8d18(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chatclient_32279974 === 'function') {
    await nuxt_plugin_chatclient_32279974(app.context, inject)
  }

  if (typeof nuxt_plugin_login_1c4d98fc === 'function') {
    await nuxt_plugin_login_1c4d98fc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
